import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          常见问题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          关于榴莲视频高清影视平台的常见疑问解答
        </p>
        <div className="space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}